export const educationData = [
    {
        id: 1,
        institution: 'Birla Institute of Technology, Mesra',
        course: 'Bachelor of Technology(AIML)',
        startYear: '2023',
        endYear: '2027'
    },
    // {
    //     id: 2,
    //     institution: 'Somerset School of Science',
    //     course: 'Bachelor of Technology',
    //     startYear: '2015',
    //     endYear: '2019'
    // },
    // {
    //     id: 3,
    //     institution: 'Hawking University, Cambridge',
    //     course: 'Master of Technology',
    //     startYear: '2019',
    //     endYear: 'Present'
    // },
]